import script from "./ProfileVolunteering.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileVolunteering.vue?vue&type=script&setup=true&lang=js"

import "./ProfileVolunteering.vue?vue&type=style&index=0&id=26c85196&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26c85196"]])

export default __exports__